import {z} from 'zod';
import {
	editEffectsSortOrder,
	type EditEffectsSortOrderParams,
	getSortField,
	type GetSortFieldParams,
	geSortOrder,
	type GetSortOrderParams,
	SortOrder,
	SortSchema,
} from '@netx/core-next/schema';
import {PersonField, type IPerson} from './personSchema';

export const PERSON_SORTABLE_FIELDS = [
	PersonField.name,
	// TODO: there are notes about creationDate / modificationDate but those are not fields exposed
	// on the `Person` currently
] as const;

export const PersonSortSchema = SortSchema.omit({
	field: true,
}).extend({
	field: z.enum(PERSON_SORTABLE_FIELDS),
});

export type IPersonSort = z.infer<typeof PersonSortSchema>;

export const PersonSortableField = z.enum(PERSON_SORTABLE_FIELDS).enum;

export const PERSON_DEFAULT_SORT_FIELD = PersonSortableField.name;

export const PERSON_DEFAULT_SORT_ORDER = SortOrder.ASCENDING;

/** will return the sort passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getPersonDefaultSort = (
	sort: Partial<IPersonSort> = {},
): IPersonSort => ({
	field: getPersonSortField({sortField: sort.field}),
	order: getPersonSortOrder({sortOrder: sort.order}),
});

/** will return the passed in sort field if valid, otherwise will retutn the default sort field */
export const getPersonSortField = (
	params: Omit<
		GetSortFieldParams<(typeof PERSON_SORTABLE_FIELDS)[number]>,
		'defaultSortField' | 'sortableFields'
	>,
) =>
	getSortField({
		...params,
		sortableFields: PERSON_SORTABLE_FIELDS,
		defaultSortField: PERSON_DEFAULT_SORT_FIELD,
	});

/** will return the passed in sort order if valid, otherwise will return the default sort order */
export const getPersonSortOrder = (
	params: Omit<GetSortOrderParams, 'defaultSortOrder'>,
) =>
	geSortOrder({
		...params,
		defaultSortOrder: PERSON_DEFAULT_SORT_ORDER,
	});

/** given the original data, the new data, and the current sort, determine if the sort order was effected */
export const personEditEffectsOrder = (
	params: Omit<
		EditEffectsSortOrderParams<
			IPerson,
			(typeof PERSON_SORTABLE_FIELDS)[number]
		>,
		'sortableFields'
	>,
) =>
	editEffectsSortOrder({
		...params,
		sortableFields: PERSON_SORTABLE_FIELDS,
	});
